<template>
  <div>
    <vs-popup
        class="after-modal"
        :title="title"
        :active.sync="showPopup"
        v-if="activeOrder !== null"
    >
      <vs-list>

        <vs-list-item v-for="detail in activeOrder.details" :key="detail.id">
          <template slot="title">
            <p>
              <vs-checkbox v-model="selected" :vs-value="detail">{{ detail.product.name }}
              </vs-checkbox>
            </p>
            <vs-input-number :min="detail.amount" :max="detail.quantity" v-model="detail.quantity"/>

          </template>
          <template slot="subtitle">
            <ul class="pl-4">
              <li v-for="addon in detail.addons" :key="addon.id">
                <vs-checkbox v-model="selectedAddons" :vs-value="addon">{{ addon.name }} {{
                    addon.price
                  }}
                </vs-checkbox>
              </li>
            </ul>
          </template>
          € {{ (detail.quantity * detail.product.price).toFixed(2) }}
        </vs-list-item>
        <vs-list-item>
          <template slot="title">
            Bezorgkosten
          </template>
          {{ activeOrder.delivery_fee }}
        </vs-list-item>
        <vs-list-item>
          <template slot="title">
            <p>Nalevering door Hebtrek betaald?</p>
          </template>
          <p>
            <vs-switch v-model="deliveryPaidByHebtrek">Nalevering door Hebtrek betaald?</vs-switch>
          </p>
        </vs-list-item>

        <vs-list-item>
          <template slot="title">
            <p>Nalevering door bezorger ({{ activeOrder.job.deliverer.firstname }}) laten betalen (inhouding van
              salaris)?</p>
          </template>
          <p>
            <vs-switch v-model="driverPays">Nalevering door Hebtrek betaald?</vs-switch>
          </p>
        </vs-list-item>
      </vs-list>
      <vs-button class="mr-3 w-full mb-2 vs-con-loading__container" id="secondary-delivery" ref="loadableButton"
                 v-if="allowSecondaryDelivery"
                 @click="createSecondaryDelivery">Nalevering aanmaken
      </vs-button>
      <vs-button class="mr-3 w-full mb-2" v-if="!allowSecondaryDelivery" disabled>Nalvering aanmaken</vs-button>
    </vs-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      driverPays: false,
      massActive: false,
      showPopup: false,
      activeOrder: null,
      selected: [],
      voucher: false,
      selectedAddons: [],
      deliveryPaidByHebtrek: false
    };
  },
  computed: {
    title() {
      if (this.activeOrder !== null) {
        return "Nalevering aanmaken voor #" + this.activeOrder.id;
      }
    },
    allowSecondaryDelivery() {
      return this.selected.length > 0 || this.selectedAddons.length > 0;
    }
  },
  mounted() {
    this.selected = [];
    this.isMounted = true;
    this.$events.listen("open-after-modal", (order) => {
      this.showPopup = true;
      this.activeOrder = order;
      console.log(order);
    });
  },

  watch: {
    deliveryPaidByHebtrek() {
      this.driverPays = !this.deliveryPaidByHebtrek;
    },

    driverPays() {
      this.deliveryPaidByHebtrek = !this.driverPays;
    }
  },
  methods: {
    createSecondaryDelivery() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#secondary-delivery",
        scale: 0.45
      });
      let note = "";
      this.selected.map((detail) => {
        note += detail.product.name;
      });
      let data = new FormData();
      data.append('note', note);
      data.append('selected', JSON.stringify(this.selected));
      data.append('selectedAddons', JSON.stringify(this.selectedAddons));
      data.append('delivery_covered_by_hebtrek', this.deliveryPaidByHebtrek);
      data.append('delivery_covered_by_driver', this.driverPays);
      data.append('parent_order_id', this.activeOrder.id);
      this.$http
          .post("https://staffapi.hebtrek.nl/v1/order/secondary-delivery/create", data, {
            headers: {
              Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
            },
          })
          .then(() => {
            this.selected = [];
            this.selectedAddons = [];
            this.showPopup = false;
            this.$vs.loading.close("#secondary-delivery > .con-vs-loading");
            this.$util.notify('Nalevering aangemaakt', 'Je kan nu een bezorger toewijzen', this.$vs);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
            this.$vs.loading.close("#secondary-delivery > .con-vs-loading");
          });
    }
  }
};
</script>
